<template>
    <div class="">
            <div class="bg-gray-100 border-b-4">
                <div class="flex flex-row items-center px-5 py-1 bg-gray-200">
                    <div class="flex-1 text-right md:text-center">
                        <span class="font-medium text-xs uppercase">{{ audience.title }}</span>
                        <h3 class="font-medium text-3xl">{{ currentAudienceCount  }}</h3>
                    </div>
                </div>
                <div class="p-5">
                    <line-bar
                        :data="chartData"
                        :options="chartOptions"
                        class="mb-5"
                        v-if="data.length > 0"
                        :height="250"
                    />
                    <div class="w-full flex items-center">
                        <div @click="setFilter(filter.id)"
                             v-for="filter in this.availableFilters"
                             class="flex-1 bg-gray-200 px-1 py-1 m-1 text-center text-xs cursor-pointer"
                             :class="{ 'border-gray-800 border-2': filter.id === activeFilter}"
                        >{{ filter.label }}</div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import LineBar from "@/Shared/Charts/LineBar";
export default {
    components: {LineBar},
    props: {
        audience: {
            type: Object
        },
        updateCount: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        this.loadData();
    },
    data() {
        return {
            availableFilters: [
                {
                    'id': '5m',
                    'label': '5m'
                },
                {
                    'id': '15m',
                    'label': '15m'
                },
                {
                    'id': '30m',
                    'label': '30m'
                },
                {
                    'id': '1h',
                    'label': '1h'
                },
                {
                    'id': '2h',
                    'label': '2h'
                }
            ],
            activeFilter: '1h',
            data: []
        }
    },
    methods: {
        setFilter(filter) {
            this.activeFilter = filter;
        },
        loadData() {
            let obj = this;
            axios.get(route('stats.viewers.trend', {'channel': obj.audience.channel, 'filter': obj.activeFilter}))
                .then((response) => {
                    obj.data = response.data;
                })
                .catch((error) => {
                    obj.data = [];
                });
        }
    },
    computed: {
        chartData() {
            return {
                labels: this.labels,
                datasets: [
                    {
                        label: 'Nutzer:innen',
                        backgroundColor: '#12144B',
                        borderColor: '#1F2937',
                        fill: false,
                        lineTension: 0,
                        data: this.values,
                        pointRadius: 3
                    }
                ]
            }
        },
        chartOptions() {
          return {
              scales: {
                  xAxes: [{
                      ticks: {
                          autoSkip: false,
                          minRotation: 90
                      }
                  }],
                  yAxes: [{
                      ticks: {
                          beginAtZero: true,
                          suggestedMin: 0,
                          stepSize: 1
                      }
                  }]
              }
          }
        },
        values() {
            if (this.data) {
                return this.data.map(({ value }) => value);
            }
            return [];
        },
        labels() {
            if (this.data) {
                return this.data.map(({ label }) => label);
            }
            return [];
        },
        currentAudienceCount() {
            if (this.data.length > 0) {
                return this.data[this.data.length - 1].current;
            }
            return 0;
        }
    },
    watch: {
        activeFilter: function(newFilter) {
            this.loadData();
        },
        updateCount: function(newUpdateCount) {
            this.loadData();
        }
    }
}
</script>
